import { createAction, handleActions } from "redux-actions";
import { APP_VERSION } from "../../const";

export const types = {
  handleRegisterFormRequest: "HANDLE_REGISTERFORM_REQUEST",
  handleRegisterFormResponse: "HANDLE_REGISTERFORM_RESPONSE",
  handleRegisterFormResponseError: "HANDLE_REGISTERFORM_RESPONSE_ERROR",
  subscribeUserRequest: "SUBSCRIBE_USER_REQUEST",
  subscribeUserResponse: "SUBSCRIBE_USER_RESPONSE",
  handleAutoLogin: "HANDLE_LOGINFORM_AUTOLOGIN",
  handleAutoLoginResponse: "HANDLE_LOGINFORM_AUTOLOGIN_RESPONSE",
  handleAutoLoginResponseError: "HANDLE_LOGINFORM_AUTOLOGIN_RESPONSE_ERROR",
  handleLoginFormLoginRequest: "HANDLE_LOGINFORM_LOGIN_REQUEST",
  handleLoginFormLoginRequesting: "HANDLE_LOGINFORM_LOGIN_REQUESTING",
  handleLoginFormLoginResponse: "HANDLE_LOGINFORM_LOGIN_RESPONSE",
  handleLoginFormLoginResponseError: "HANDLE_LOGINFORM_LOGIN_RESPONSE_ERROR",
  handleLoginFormNeedsSync: "HANDLE_LOGINFORM_NEEDS_SYNC",
  updateProshop: "UPDATE_PROSHOP",
  profileHandleForm: "HANDLE_PROFILE_FORM",
  hideFreesubscriptionModal: "HIDE_FREESUBSCRIPTION_MODAL",
  showFreesubscriptionModal: "SHOW_FREESUBSCRIPTION_MODAL",
  getDeviceInfo: "GET_DEVICE_INFO",
  setDeviceInfo: "SET_DEVICE_INFO",
  handleUpdatePassword: "HANDLE_UPDATE_PASSWORD",
  handleUpdatePasswordError: "HANDLE_UPDATE_PASSWORD_ERROR",
  setShowUpdatePasswordModal: "SET_SHOW_UPDATE_PASSWORD_MODAL",
  handleLogout: "HANDLE_LOGOUT",
  setRegisterError: "SET_REGISTER_ERROR",
  getSubscriptionType: "GET_SUBSCRIPTION_TYPE",
  getSubscriptionTypeResponse: "GET_SUBSCRIPTION_TYPE_RESPONSE",
  startApp: "START_APP",
  appStarted: "APP_STARTED",
  clearPromoCode: "CLEAR_PROMO_CODE",
  getPromoCode: "GET_PROMO_CODE",
  getPromoCodeResponse: "GET_PROMO_CODE_RESPONSE",
  setHasPromoCode: "SET_HAS_PROMO_CODE",
  setWelcomeShown: "SET_WELCOME_SHOWN",
  setVersionNumber: "SET_VERSION_NUMBER",
  handleOpenCustomerPortal: "HANDLE_OPEN_CUSTOMER_PORTAL",
  customerPortalOpened: "OPEN_CUSTOMER_PORTAL_OPENED",
  createRegistrationQuote: "CREATE_REGISTRATION_QUOTE",
  updateRegistrationQuote: "UPDATE_REGISTRATION_QUOTE",
  deleteRegistrationQuote: "DELETE_REGISTRATION_QUOTE",
  setRegistrationQuote: "SET_REGISTRATION_QUOTE",
  getRegistrationQuote: "GET_REGISTRATION_QUOTE",
  updateSharedSettings: "UPDATE_SHARED_SETTINGS",
  openPhoto: "OPEN_PHOTO",
  closePhoto: "CLOSE_PHOTO",
  uploadLogo: "UPLOAD_LOGO",
  logoUploaded: "LOGO_UPLOADED",
  setReferralCode: "SET_REFERRAL_CODE",
  subscriptionPollingStart: "SUBSCRIPTION_POLLING_START",
  subscriptionPollingStop: "SUBSCRIPTION_POLLING_STOP",
  subscriptionActivated: "SUBSCRIPTION_ACTIVATED",
  subscriptionActivationTimedOut: "SUBSCRIPTION_ACTIVATION_TIMED_OUT",
  dismissSubscriptionBanner: "DISMISS_SUBSCRIPTION_BANNER",
};

export const handleRegisterFormRequest = createAction(
  types.handleRegisterFormRequest
);
export const handleRegisterFormResponse = createAction(
  types.handleRegisterFormResponse
);
export const handleRegisterFormResponseError = createAction(
  types.handleRegisterFormResponseError
);

export const handleAutoLogin = createAction(types.handleAutoLogin);
export const handleAutoLoginResponse = createAction(
  types.handleAutoLoginResponse
);
export const handleAutoLoginResponseError = createAction(
  types.handleAutoLoginResponseError
);

export const handleLoginFormLoginRequest = createAction(
  types.handleLoginFormLoginRequest
);

export const handleLoginFormLoginRequesting = createAction(
  types.handleLoginFormLoginRequesting
);

export const handleLoginFormLoginResponse = createAction(
  types.handleLoginFormLoginResponse
);

export const handleLoginFormLoginResponseError = createAction(
  types.handleLoginFormLoginResponseError
);

export const handleLoginFormNeedsSync = createAction(
  types.handleLoginFormNeedsSync
);

export const updateProshop = createAction(types.updateProshop);

export const profileHandleForm = createAction(types.profileHandleForm);

export const hideFreesubscriptionModal = createAction(
  types.hideFreesubscriptionModal
);

export const showFreesubscriptionModal = createAction(
  types.showFreesubscriptionModal
);

export const setShowUpdatePasswordModal = createAction(
  types.setShowUpdatePasswordModal
);

export const handleUpdatePassword = createAction(types.handleUpdatePassword);
export const handleUpdatePasswordError = createAction(
  types.handleUpdatePasswordError
);

export const handleLogout = createAction(types.handleLogout);

export const getDeviceInfo = createAction(types.getDeviceInfo);
export const setDeviceInfo = createAction(types.setDeviceInfo);
export const setRegisterError = createAction(types.setRegisterError);
export const getSubscriptionType = createAction(types.getSubscriptionType);
export const getSubscriptionTypeResponse = createAction(
  types.getSubscriptionTypeResponse
);
export const startApp = createAction(types.startApp);
export const appStarted = createAction(types.appStarted);
export const clearPromoCode = createAction(types.clearPromoCode);
export const getPromoCode = createAction(types.getPromoCode);
export const getPromoCodeResponse = createAction(types.getPromoCodeResponse);
export const setHasPromoCode = createAction(types.setHasPromoCode);
export const setWelcomeShown = createAction(types.setWelcomeShown);
export const setVersionNumber = createAction(types.setVersionNumber);
export const handleOpenCustomerPortal = createAction(
  types.handleOpenCustomerPortal
);
export const customerPortalOpened = createAction(types.customerPortalOpened);

export const createRegistrationQuote = createAction(
  types.createRegistrationQuote
);
export const updateRegistrationQuote = createAction(
  types.updateRegistrationQuote
);
export const deleteRegistrationQuote = createAction(
  types.deleteRegistrationQuote
);
export const setRegistrationQuote = createAction(types.setRegistrationQuote);
export const getRegistrationQuote = createAction(types.getRegistrationQuote);
export const updateSharedSettings = createAction(types.updateSharedSettings);
export const openPhoto = createAction(types.openPhoto);

export const subscriptionPollingStart = createAction(types.subscriptionPollingStart);
export const subscriptionPollingStop = createAction(types.subscriptionPollingStop);
export const subscriptionActivated = createAction(types.subscriptionActivated);
export const subscriptionActivationTimedOut = createAction(types.subscriptionActivationTimedOut);
export const dismissSubscriptionBanner = createAction(types.dismissSubscriptionBanner);
export const closePhoto = createAction(types.closePhoto);

export const uploadLogo = createAction(types.uploadLogo);
export const logoUploaded = createAction(types.logoUploaded);

export const subscribeUserRequest = createAction(types.subscribeUserRequest);
export const subscribeUserResponse = createAction(types.subscribeUserResponse);

export const setReferralCode = createAction(types.setReferralCode);

export const INITIAL_STATE = {
  username: "",
  rememberme: false,
  requesting: false,
  logged: false,
  userData: {},
  accessData: {},
  loginData: {},
  deviceData: {},
  needsSync: false,
  proshopId: "",
  error: "",
  registerError: "",
  isSessionLoaded: false,
  requestError: "",
  isFreeSubscription: false,
  showFreesubscriptionModal: false,
  isPaypalSubscription: false,
  isStripeSubscription: false,
  isPaddleSubscription: false,
  showPaypalSubscriptionModal: false,
  isReadOnly: false,
  subscription: {},
  subscriptionInfo: {},
  deviceInfo: {},
  showUpdatePasswordModal: false,
  updatePasswordError: "",
  subscriptionType: [],
  appStarted: false,
  isSandbox: true,
  promoCode: null,
  registeringUser: false,
  subscriptionActivating: false,
  subscriptionActivatingDismissed: false,
  subscriptionActivatingTimedOut: false,
  validatingPromoCode: false,
  hasPromoCode: false,
  proshop: {},
  versionNumber: APP_VERSION * 1,
  welcomeShown: true,
  patchNotes: [],
  showPatchNotes: false,
  welcomePost: {},
  registrationQuote: {},
  isCAD: false,
  takingPhoto: false,
  uploadingLogo: false,
  referralCode: "",
};

export const userSessionReducer = handleActions(
  {
    [types.handleLoginFormLoginRequest]: (state, action) => ({
      ...state,
      error: "",
      username: action.username,
      requesting: true,
      registeringUser: false,
    }),
    [types.handleResponseFormRequest]: (state, action) => ({
      ...state,
      username: action.username,
      requesting: true,
    }),
    [types.handleRegisterFormRequest]: (state, action) => ({
      ...state,
      registerError: "",
      requesting: true,
      registeringUser: true,
    }),
    [types.handleRegisterFormResponseError]: (state, action) => ({
      ...state,
      registerError: action.payload.error,
      requesting: false,
      registeringUser: false,
    }),
    [types.setRegisterError]: (state, action) => ({
      ...state,
      registerError: action.payload.error,
    }),
    [types.handleLoginFormLoginResponse]: (state, action) => ({
      ...state,
      userData: action.payload.userData,
      accessData: action.payload.accessData,
      loginData: action.payload.loginData,
      deviceData: action.payload.deviceData,
      needsSync: action.payload.needsSync,
      logged: action.payload.logged,
      session_info: action.payload.session_info,
      error: action.payload.error,
      proshopId: action.payload.userData.proshops[0].proshop.id,
      requesting: false,
      isSessionLoaded: true,
      isFreeSubscription:
        action.payload.userData.subscription.type === "FREE" ||
        (action.payload.subscriptionInfo.status.toLowerCase() !== "active" &&
          action.payload.subscriptionInfo.status.toLowerCase() !== "trialing"),
      isPaypalSubscription:
        action.payload.userData.subscription.type === "PAYPAL" ||
        action.payload.userData.subscription.type === "PAYPAL_SANDBOX",
      isStripeSubscription:
        action.payload.userData.subscription.type === "STRIPE" ||
        action.payload.userData.subscription.type === "STRIPE_SANDBOX",
      isPaddleSubscription:
        action.payload.userData.subscription.type === "PADDLE" ||
        action.payload.userData.subscription.type === "PADDLE_SANDBOX",
      showFreesubscriptionModal:
        action.payload.userData.subscription.type === "FREE" ||
        (action.payload.subscriptionInfo.status.toLowerCase() !== "active" &&
          action.payload.subscriptionInfo.status.toLowerCase() !== "trialing"),
      isReadOnly:
        // action.payload.userData.subscription.type === "PAYPAL" ||
        // action.payload.userData.subscription.type === "PAYPAL_SANDBOX" ||
        action.payload.userData.subscription.type === "FREE" ||
        (action.payload.subscriptionInfo.status.toLowerCase() !== "active" &&
          action.payload.subscriptionInfo.status.toLowerCase() !== "trialing"),
      subscription: action.payload.userData.subscription,
      subscriptionInfo: action.payload.subscriptionInfo,
      proshop: action.payload.userData.proshops[0]?.proshop || {},
      isCAD:
        (
          action.payload.subscriptionInfo?.currency ||
          action.payload.subscriptionInfo?.currency_code ||
          ""
        ).toLowerCase() === "cad",
      isSandbox:
        action.payload.userData.subscription.type === "PAYPAL_SANDBOX" ||
        action.payload.userData.subscription.type === "STRIPE_SANDBOX" ||
        action.payload.userData.subscription.type === "PADDLE_SANDBOX",
    }),
    [types.handleLoginFormLoginResponseError]: (state, action) => ({
      ...state,
      error: action.payload.error,
      requesting: false,
      isSessionLoaded: true,
    }),
    [types.handleAutoLoginResponse]: (state, action) => ({
      ...state,
      userData: action.payload.userData,
      accessData: action.payload.accessData,
      loginData: action.payload.loginData,
      deviceData: action.payload.deviceData,
      needsSync: action.payload.needsSync,
      logged: action.payload.logged,
      session_info: action.payload.session_info,
      error: action.payload.error,
      proshopId: action.payload.userData.proshops[0].proshop.id,
      requesting: false,
      isSessionLoaded: true,
      isFreeSubscription:
        action.payload.userData.subscription.type === "FREE" ||
        (action.payload.subscriptionInfo.status.toLowerCase() !== "active" &&
          action.payload.subscriptionInfo.status.toLowerCase() !== "trialing"),
      subscription: action.payload.userData.subscription,
      isPaypalSubscription:
        action.payload.userData.subscription.type === "PAYPAL" ||
        action.payload.userData.subscription.type === "PAYPAL_SANDBOX",
      isStripeSubscription:
        action.payload.userData.subscription.type === "STRIPE" ||
        action.payload.userData.subscription.type === "STRIPE_SANDBOX",
      isPaddleSubscription:
        action.payload.userData.subscription.type === "PADDLE" ||
        action.payload.userData.subscription.type === "PADDLE_SANDBOX",
      showFreesubscriptionModal:
        action.payload.userData.subscription.type === "FREE" ||
        (action.payload.subscriptionInfo.status.toLowerCase() !== "active" &&
          action.payload.subscriptionInfo.status.toLowerCase() !== "trialing"),
      isReadOnly:
        // action.payload.userData.subscription.type === "PAYPAL" ||
        // action.payload.userData.subscription.type === "PAYPAL_SANDBOX" ||
        action.payload.userData.subscription.type === "FREE" ||
        (action.payload.subscriptionInfo.status.toLowerCase() !== "active" &&
          action.payload.subscriptionInfo.status.toLowerCase() !== "trialing"),
      subscriptionInfo: action.payload.subscriptionInfo,
      proshop: action.payload.userData.proshops[0]?.proshop || {},
      isCAD:
        (
          action.payload.subscriptionInfo?.currency ||
          action.payload.subscriptionInfo?.currency_code ||
          ""
        ).toLowerCase() === "cad",
      isSandbox:
        action.payload.userData.subscription.type === "PAYPAL_SANDBOX" ||
        action.payload.userData.subscription.type === "STRIPE_SANDBOX" ||
        action.payload.userData.subscription.type === "PADDLE_SANDBOX",
    }),
    [types.handleAutoLoginResponseError]: (state, action) => ({
      ...state,
      requestError: action.error,
      requesting: false,
      isSessionLoaded: true,
    }),
    [types.handleLoginFormNeedsSync]: (state, action) => ({
      ...state,
      needsSync: action.payload.needsSync,
    }),
    [types.hideFreesubscriptionModal]: (state) => ({
      ...state,
      showFreesubscriptionModal: false,
    }),
    [types.showFreesubscriptionModal]: (state) => ({
      ...state,
      showFreesubscriptionModal: true,
    }),
    [types.setDeviceInfo]: (state, action) => ({
      ...state,
      deviceInfo: action.payload.deviceInfo,
      showPatchNotes: action.payload.versionNumber
        ? action.payload.versionNumber * 1 < state.versionNumber
        : true,
      welcomeShown: action.payload.welcomeShown,
      patchNotes: action.payload.patchNotes,
      welcomePost: action.payload.welcomePost,
    }),
    [types.setShowUpdatePasswordModal]: (state, action) => ({
      ...state,
      showUpdatePasswordModal: action.payload.show,
    }),
    [types.updatePasswordError]: (state, action) => ({
      ...state,
      updatePasswordError: action.payload.error,
    }),
    [types.getSubscriptionType]: (state) => ({
      ...state,
      subscriptionType: [],
    }),
    [types.getSubscriptionTypeResponse]: (state, action) => ({
      ...state,
      subscriptionType: action.payload.subscriptionType,
    }),
    [types.appStarted]: (state, action) => ({
      ...state,
      isSandbox: action.payload.isSandbox,
      appStarted: true,
    }),
    [types.getPromoCode]: (state) => ({
      ...state,
      promoCode: null,
      validatingPromoCode: true,
    }),
    [types.clearPromoCode]: (state, action) => ({
      ...state,
      promoCode: null,
      validatingPromoCode: false,
    }),
    [types.getPromoCodeResponse]: (state, action) => ({
      ...state,
      promoCode: action.payload.promoCode,
      validatingPromoCode: false,
    }),
    [types.setHasPromoCode]: (state, action) => ({
      ...state,
      hasPromoCode: action.payload.hasPromoCode,
    }),
    [types.updateProshop]: (state, action) => ({
      ...state,
      proshop: action.payload.proshop,
      userData: action.payload.app_user,
    }),
    [types.setWelcomeShown]: (state, action) => ({
      ...state,
      welcomeShown: action.payload.welcomeShown,
    }),
    [types.setVersionNumber]: (state, action) => ({
      ...state,
      showPatchNotes: false,
    }),
    [types.getRegistrationQuote]: (state) => ({
      ...state,
      registrationQuote: {},
    }),
    [types.setRegistrationQuote]: (state, action) => ({
      ...state,
      registrationQuote: action.payload.registrationQuote,
    }),
    [types.openPhoto]: (state) => ({
      ...state,
      takingPhoto: true,
    }),
    [types.closePhoto]: (state) => {
      console.log("Reducer handling closePhoto action");
      return {
        ...state,
        takingPhoto: false,
      };
    },
    [types.uploadLogo]: (state) => ({
      ...state,
      uploadingLogo: true,
    }),
    [types.logoUploaded]: (state, action) => ({
      ...state,
      uploadingLogo: false,
      proshop: action.payload.proshop,
    }),
    [types.subscribeUserRequest]: (state) => ({
      ...state,
      registeringUser: true,
    }),
    [types.subscribeUserResponse]: (state) => ({
      ...state,
      registeringUser: false,
    }),
    [types.setReferralCode]: (state, action) => ({
      ...state,
      referralCode: action.payload.referralCode,
    }),
    [types.subscriptionPollingStart]: (state) => ({
      ...state,
      subscriptionActivating: true,
      subscriptionActivatingDismissed: false,
      subscriptionActivatingTimedOut: false,
    }),
    [types.subscriptionPollingStop]: (state) => ({
      ...state,
      subscriptionActivating: false,
    }),
    [types.subscriptionActivated]: (state) => ({
      ...state,
      subscriptionActivating: false,
      subscriptionActivatingDismissed: false,
      subscriptionActivatingTimedOut: false,
    }),
    [types.subscriptionActivationTimedOut]: (state) => ({
      ...state,
      subscriptionActivatingTimedOut: true,
    }),
    [types.dismissSubscriptionBanner]: (state) => ({
      ...state,
      subscriptionActivatingDismissed: true,
    }),
  },
  INITIAL_STATE
);
